// import Writs from './Writs';

export default {
  priority: 94,
  name: app.translate("routes.home.attendance.writs.Writs"),
  path: "writs",
  permissions: ["TimeAttendanceMenu/WritMenu"],
  // component: Writs,
  component: load(() => import(/* webpackChunkName: "Writs" */ "./Writs")),
  icon: "folder-open",
  drawer: true,
};
